const TOKEN_KEY = 'authToken';

export const tokenStorage = {
  set: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  get: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  remove: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  has: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
  },
};
